// @ts-nocheck
import * as Types from "../../../../types/types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type GetQueryAdvisorDataQueryVariables = Types.Exact<{
  serverId: Types.Scalars["ID"]["input"];
  databaseId: Types.Scalars["ID"]["input"];
  startTs: Types.Scalars["Int"]["input"];
  endTs: Types.Scalars["Int"]["input"];
}>;

export type GetQueryAdvisorDataQuery = {
  __typename?: "GraphqlQuery";
  getIssues: Array<{
    __typename?: "Issue";
    id: string;
    details: any;
    queryText?: string | null;
    references: Array<{
      __typename?: "IssueReference";
      referentId: string;
      kind: string;
    }>;
  }>;
  getWorkbooks: Array<{
    __typename?: "Workbook";
    id: string;
    name: string;
    description?: string | null;
    createdAt: number;
    lastActivityAt: number;
    variantsCount: number;
    draft: boolean;
    insights?: Array<string> | null;
    user?: { __typename?: "User"; id: string; fullname?: string | null } | null;
  }>;
  getDatabaseDetails: {
    __typename?: "Database";
    id: string;
    permittedToCreateWorkbooks: boolean;
  };
  getQueryExplainStats: {
    __typename?: "QueryExplainStats";
    id: string;
    totalExplainCount: number;
    stats: Array<{
      __typename?: "QuerySummaryStatsWithExplain";
      id: string;
      callsPerMinute: number;
      pctOfTotal: number;
      explainExists: boolean;
    }>;
  };
};

export const GetQueryAdvisorDataDocument = gql`
  query GetQueryAdvisorData(
    $serverId: ID!
    $databaseId: ID!
    $startTs: Int!
    $endTs: Int!
  ) {
    getIssues(
      serverId: $serverId
      databaseId: $databaseId
      checkGroupsAndNames: ["queries/advisor_insight"]
    ) {
      id
      details
      queryText
      references {
        referentId
        kind
      }
    }
    getWorkbooks(databaseId: $databaseId, withInsightsOnly: true) {
      id
      name
      description
      createdAt
      lastActivityAt
      variantsCount
      draft
      insights
      user {
        id
        fullname
      }
    }
    getDatabaseDetails(databaseId: $databaseId) {
      id
      permittedToCreateWorkbooks
    }
    getQueryExplainStats(
      databaseId: $databaseId
      startTs: $startTs
      endTs: $endTs
    ) {
      id
      stats {
        id
        callsPerMinute
        pctOfTotal
        explainExists
      }
      totalExplainCount
    }
  }
`;

/**
 * __useGetQueryAdvisorDataQuery__
 *
 * To run a query within a React component, call `useGetQueryAdvisorDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQueryAdvisorDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQueryAdvisorDataQuery({
 *   variables: {
 *      serverId: // value for 'serverId'
 *      databaseId: // value for 'databaseId'
 *      startTs: // value for 'startTs'
 *      endTs: // value for 'endTs'
 *   },
 * });
 */
export function useGetQueryAdvisorDataQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetQueryAdvisorDataQuery,
    GetQueryAdvisorDataQueryVariables
  > &
    (
      | { variables: GetQueryAdvisorDataQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetQueryAdvisorDataQuery,
    GetQueryAdvisorDataQueryVariables
  >(GetQueryAdvisorDataDocument, options);
}
export function useGetQueryAdvisorDataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetQueryAdvisorDataQuery,
    GetQueryAdvisorDataQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetQueryAdvisorDataQuery,
    GetQueryAdvisorDataQueryVariables
  >(GetQueryAdvisorDataDocument, options);
}
// @ts-ignore
export function useGetQueryAdvisorDataSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetQueryAdvisorDataQuery,
    GetQueryAdvisorDataQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetQueryAdvisorDataQuery,
  GetQueryAdvisorDataQueryVariables
>;
export function useGetQueryAdvisorDataSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetQueryAdvisorDataQuery,
        GetQueryAdvisorDataQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetQueryAdvisorDataQuery | undefined,
  GetQueryAdvisorDataQueryVariables
>;
export function useGetQueryAdvisorDataSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetQueryAdvisorDataQuery,
        GetQueryAdvisorDataQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetQueryAdvisorDataQuery,
    GetQueryAdvisorDataQueryVariables
  >(GetQueryAdvisorDataDocument, options);
}
export type GetQueryAdvisorDataQueryHookResult = ReturnType<
  typeof useGetQueryAdvisorDataQuery
>;
export type GetQueryAdvisorDataLazyQueryHookResult = ReturnType<
  typeof useGetQueryAdvisorDataLazyQuery
>;
export type GetQueryAdvisorDataSuspenseQueryHookResult = ReturnType<
  typeof useGetQueryAdvisorDataSuspenseQuery
>;
export type GetQueryAdvisorDataQueryResult = Apollo.QueryResult<
  GetQueryAdvisorDataQuery,
  GetQueryAdvisorDataQueryVariables
>;
